module.exports = __webpack_public_path__ + "img/logo.0870e33c.png";